export const Environment = {
  Development: 'development',
  Staging: 'staging',
  Production: 'production',
} as const
export type Environment = typeof Environment[keyof typeof Environment]
